import {MetricTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class MetricTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in MetricTypeCd ) {
      this._values.push(MetricTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): MetricTypeCd {

    for ( const obj in MetricTypeCd ) {
      if (MetricTypeCd[obj] === value){
        return MetricTypeCd[obj] as MetricTypeCd;
      }
    }
  }
}

const MetricTypeCdHelper = new MetricTypeCdHelperEnumHelperClass();
export default MetricTypeCdHelper;
